<template>
    <div id="app">
        <input style="width: 0;height:0;border: 0;float: left" type="password" />
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted:function(){
        var theme_key = this.$base.getTheme();
        if(!theme_key){
            theme_key = 'theme_df';
        }
        this.changeTheme(theme_key);
    },
    computed:{
        theme_key: function() {
            return this.$store.state.baseData.theme_key;
        }
    },
    methods: {
        changeTheme:function(styleName) {
            styleName = './static/element_theme/' + styleName;
            var link = document.querySelector('#theme_style');
            if (link) {
                link.href = styleName+'.css'; // 更新href属性来切换CSS文件

                link = document.querySelector('#theme_style_ex');
                link.href = styleName+'_ex.css'; // 更新href属性来切换CSS文件

                var head = document.head || document.getElementsByTagName('head')[0];
            } else {
                var head = document.head || document.getElementsByTagName('head')[0];
                var style = document.createElement('link');
                style.id = 'theme_style'; // 确保每个页面只有一个动态样式链接
                style.rel = 'stylesheet';
                style.href = styleName+'.css';
                head.appendChild(style);

                style = document.createElement('link');
                style.id = 'theme_style_ex'; // 确保每个页面只有一个动态样式链接
                style.rel = 'stylesheet';
                style.href = styleName+'_ex.css';
                head.appendChild(style);

                style = document.createElement('link');
                style.id = 'element_ex'; // 确保每个页面只有一个动态样式链接
                style.rel = 'stylesheet';
                style.href = './static/element_theme/element_ex.css';
                head.appendChild(style);
            }
        }
    },
    watch:{
        theme_key(newVal,oldVal){
            this.changeTheme(newVal);
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue